/* eslint-disable no-console */

import React, { useEffect } from 'react';
import { Form } from 'antd';
import * as yup from 'yup';
import { useFormik } from 'formik';
import PageStyle from './style';

import { SpinStyle } from 'src/components/style';

import { useAppDispatch, useAppSelector } from 'src/stores';
import Breadcrumb from 'src/components/breadcrumb';
import { EMAIL_REGEX } from 'src/constants';
import { InputField } from 'src/components/form';
import { Button } from 'src/components';
import {
  mailConfigAction,
  settingMailConfigAction,
} from 'src/stores/screens/mail/mail.action';

const MailtoSettingScreen: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isLoading, mailConfig } = useAppSelector((state) => state.mail);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    await dispatch(mailConfigAction({}));
  };

  console.log('mailConfig: ', mailConfig);

  const validationSchema = yup.object().shape({
    toAddress: yup
      .string()
      .trim()
      .matches(EMAIL_REGEX, 'Please enter a valid email address.')
      .max(
        255,
        'Email must be 255 characters or less.'
      )
      .email('Please enter a valid email address.')
      .required('Email is required'),
  });

  const initialValues: Mail.MailConfig = {
    id: mailConfig?.id || '',
    toAddress: mailConfig?.toAddress || '',
  };

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues,
    onSubmit: async (values: Mail.MailConfig) => {
      await dispatch(
        settingMailConfigAction({
          data: {
            ...values,
            toAddress: values.toAddress.trim(),
          },
        })
      );

      fetchData()
      formik.resetForm({});
    },
  });

  return (
    <PageStyle className="container">
      <SpinStyle
        spinning={isLoading}
        wrapperClassName="root-spin"
        className="root-spin-component"
      >
        <div className="header-content">
          <Breadcrumb
            breadcrumbItems={[
              {
                name: 'Mailto',
                path: '/mail-setting',
              },
            ]}
          />
        </div>
        <div className="content">
          <Form
            name="edit-form"
            className="setting-form"
            layout="vertical"
            onFinish={() => {
              formik.handleSubmit();
            }}
          >
            <InputField
              className="form-control"
              label="To Email Address"
              field={formik.getFieldProps('toAddress')}
              setFieldValue={formik.setFieldValue}
              inputProps={{
                size: 'middle',
                placeholder: 'To Email Address',
              }}
              error={formik.errors.toAddress}
              touched={formik.touched.toAddress}
              required
            />

            <div className="box-action">
              <Button htmlType="submit" width={100} disabled={isLoading}>
                Setting
              </Button>
            </div>
          </Form>
        </div>
      </SpinStyle>
    </PageStyle>
  );
};

export default MailtoSettingScreen;
